const SecurityPermissionDashBoard = () => {

    return ( 
    <>
    <div className="jumbotron mt-5">
  <h1 className="display-4">Security Permission DashBoard</h1>
  <p className="lead">Welcome to Permission Dashboard</p>
  <hr className="my-4"/>
  <p>This module is used for providing access to users.</p>
  <p className="lead">
    {/* <a className="btn btn-primary btn-lg" href="#" role="button">Learn more</a> */}
  </p>
</div>
    
    </> );
}
 
export default SecurityPermissionDashBoard;